export default __webpack_public_path__ + "static/media/MD20_Login page_ photo.b4383e58.jpg";